import React, { Component } from 'react';
import {Link, browserHistory } from 'react-router';
import Footer from 'components/FooterComponent';
import API from 'sources/API';

require('./Destinations.scss');
require('./SearchWrap.scss');

class DestinationsComponent extends Component{
  constructor(props) {
    super(props);
    this.state = {
      categories: [
        {name: '热门', id: 'c0'},
        {name: '免签', id: 'c1'},
        {name: '非洲', id: 'c6'},
        {name: '亚洲', id: 'c3'},
        {name: '欧洲', id: 'c4'},
      ],
      categories2: [ 
        {name: '大洋洲', id: 'c5'},
        {name: '北美洲', id: 'c7'},
        {name: '南美洲', id: 'c8'},
        {name: '落地签', id: 'c2'}
      ],
      countries: {
      },
      currentId: 'c0'
    };
    this.acquireDestinations = this.acquireDestinations.bind(this)
    this.onCategoryChange = this.onCategoryChange.bind(this)
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }

    window.wx.ready(()=>{
      let imgUrl = 'https://img.xiaodiqiu.cn/share.png';
      window.wx.onMenuShareTimeline({
        title: `加入小地球旅行，发现本星球最有趣的地方`,
        link: location.href,
        imgUrl: imgUrl
      });
      window.wx.onMenuShareAppMessage({
        title: `小地球旅行`,
        desc: '加入小地球旅行，发现本星球最有趣的地方',
        link: location.href,
        type: 'link'
      });
    });

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
    window.changeMetaForSEO(false);

    this.acquireDestinations("c0")
  }
  onCategoryChange(category_id){
    if (!this.state.countries[category_id]) {
      this.acquireDestinations(category_id)
    }
    this.setState({currentId: category_id})
  }
  acquireDestinations(category_id) {
    fetch(API.getDestinations.replace(':id', category_id))
    .then(res=>res.json())
    .then(json=>{
      if (json.status === 0) {
        let countries = this.state.countries
        countries[category_id] = json.data
        this.setState({countries: countries})
      }
    });
  }
  render(){
    let countries = [];
    if (this.state.countries[this.state.currentId]) {
      countries = this.state.countries[this.state.currentId]; 
    }
    return (
      <div className="destinations-component">
        <div className="search-input-wrap">
          <input className="search-input" placeholder="搜索" onClick={() => {browserHistory.push('/search')}} />
        </div>
        <div className="center">
          <div className="countries">
            {countries.map(ele => {
              return (
                <Link to={`/feature/${ele.id}?type=location&name=${ele.name}`} className="country" key={ele.id}>
                  <div className="cover">
                    <img src={encodeURI(`${ele.cover}!li150`)}></img>
                  </div>
                  <div className="name">
                    {ele.name}
                  </div>
                </Link>
              )
            })}
            <div className="clear"></div>
          </div>
        </div>
        <div className="bottom">
          <div className="categories">
            {this.state.categories.map(ele => {
              return <div 
                className={this.state.currentId ==  ele.id?'item active':'item'} 
                key={ele.id}
                onClick={this.onCategoryChange.bind(this,ele.id)}
                >
                {ele.name} 
              </div>
            })}
          </div>
          <div className="categories">
            {this.state.categories2.map(ele => {
              return <div 
                className={this.state.currentId ==  ele.id?'item active':'item'} 
                key={ele.id}
                onClick={this.onCategoryChange.bind(this,ele.id)}
                >
                {ele.name} 
              </div>
            })}
          </div> 
        </div>
        <Footer activeTab='destinations'/>
      </div>
    );
  }
}

export default DestinationsComponent;




// WEBPACK FOOTER //
// ./src/develop/DestinationsComponent.js